
// document.addEventListener("DOMContentLoaded", function () {

//   // ────────────────────────────────────────────────
//   // TAB SWITCHING + CATEGORY CARD CLICK + ACTIVE CLASS
//   // ────────────────────────────────────────────────
//   document.querySelectorAll('.tab, .category-card').forEach(item => {
//     item.addEventListener('click', () => {
//       const isCategoryCard = item.classList.contains('category-card');
//       const isAllTab       = item.dataset.filter === 'all';
//       const category       = item.dataset.category;
//       const subcategory    = item.dataset.sub || null;

//       document.querySelectorAll('.tab').forEach(tab => tab.classList.remove('active'));

//       if (!isCategoryCard) {
//         item.classList.add('active');
//       }

//       if (isCategoryCard && category) {
//         const matchingTab = document.querySelector(`.tab.category-tab[data-category="${category}"]`);
//         if (matchingTab) {
//           matchingTab.classList.add('active');
//           const subTabs = matchingTab.nextElementSibling;
//           if (subTabs?.classList.contains('sub-tabs')) {
//             document.querySelectorAll('.sub-tabs').forEach(s => {
//               if (s !== subTabs) s.style.display = 'none';
//             });
//             subTabs.style.display = 'block';
//           }
//         }
//       }

//       document.querySelectorAll('.view').forEach(view => {
//         view.classList.remove('active');

//         if (isAllTab && view.dataset.view === 'all') {
//           view.classList.add('active');
//           return;
//         }

//         if (category && !subcategory && view.dataset.category === category) {
//           view.classList.add('active');
//         }

//         if (subcategory && view.dataset.category === category && view.dataset.sub === subcategory) {
//           view.classList.add('active');
//         }
//       });
//     });
//   });

//   // ────────────────────────────────────────────────
//   // CATEGORY ACCORDION (sub-tabs open/close)
//   // ────────────────────────────────────────────────
//   document.querySelectorAll('.category-tab').forEach(tab => {
//     tab.addEventListener('click', (e) => {
//       e.stopPropagation();
//       const subTabs = tab.nextElementSibling;
//       if (!subTabs || !subTabs.classList.contains('sub-tabs')) return;

//       document.querySelectorAll('.sub-tabs').forEach(s => {
//         if (s !== subTabs) s.style.display = 'none';
//       });

//       subTabs.style.display = subTabs.style.display === 'block' ? 'none' : 'block';
//     });
//   });

//   // ────────────────────────────────────────────────
//   // VIDEO HOVER ON CARDS
//   // ────────────────────────────────────────────────
//   document.querySelectorAll('.bundle-product-card').forEach(card => {
//     const video = card.querySelector('video');
//     if (!video) return;

//     card.addEventListener('mouseenter', () => {
//       video.currentTime = 0;
//       video.play().catch(() => {});
//     });
//     card.addEventListener('mouseleave', () => video.pause());
//   });

//   // ────────────────────────────────────────────────
//   // PRODUCT POPUP ELEMENTS
//   // ────────────────────────────────────────────────
//   const productPopup     = document.getElementById('productPopup');
//   if (!productPopup) return;

//   const popupImage       = document.getElementById('popupImage');
//   const popupVideo       = document.getElementById('popupVideo');
//   const popupVideoSrc    = document.getElementById('popupVideoSrc');
//   const popupTitle       = document.getElementById('popupTitle');
//   const popupPrice       = document.getElementById('popupPrice');
//   const popupDesc        = document.getElementById('popupDesc');
//   const popupAdd         = document.getElementById('popupAdd');
//   const popupBuy         = document.getElementById('popupBuy');
//   const videoToggle      = document.getElementById('videoToggle');

//   // ────────────────────────────────────────────────
//   // VIDEO PLAY/PAUSE in PRODUCT POPUP
//   // ────────────────────────────────────────────────
//   document.addEventListener("DOMContentLoaded", () => {
//     const video = document.getElementById("popupVideo");
//     const toggleBtn = document.getElementById("videoToggle");
//     const currentTimeEl = document.getElementById("vcur");
//     const durationEl   = document.getElementById("vdur");

//     if (!video || !toggleBtn) return;

//     // Format time MM:SS
//     function formatTime(seconds) {
//       const min = Math.floor(seconds / 60);
//       const sec = Math.floor(seconds % 60);
//       return `${min}:${sec.toString().padStart(2, "0")}`;
//     }

//     // Update duration once when metadata is loaded
//     video.addEventListener("loadedmetadata", () => {
//       durationEl.textContent = formatTime(video.duration || 0);
//     });

//     // Update current time continuously
//     video.addEventListener("timeupdate", () => {
//       currentTimeEl.textContent = formatTime(video.currentTime);
//     });

//     // Play / Pause toggle
//     toggleBtn.addEventListener("click", () => {
//       if (video.paused || video.ended) {
//         video.play().catch(e => console.log("Play prevented:", e));
//         toggleBtn.textContent = "❚❚";
//         toggleBtn.classList.remove("yt-play");
//         toggleBtn.classList.add("yt-pause");
//       } else {
//         video.pause();
//         toggleBtn.textContent = "▶";
//         toggleBtn.classList.remove("yt-pause");
//         toggleBtn.classList.add("yt-play");
//       }
//     });

//     // Optional: clicking video itself also toggles play/pause
//     video.addEventListener("click", () => {
//       toggleBtn.click();
//     });

//     // Reset button to play icon when video ends
//     video.addEventListener("ended", () => {
//       toggleBtn.textContent = "▶";
//       toggleBtn.classList.remove("yt-pause");
//       toggleBtn.classList.add("yt-play");
//     });
//   });

//   // ────────────────────────────────────────────────
//   // OPEN POPUP FROM PRODUCT CARD
//   // ────────────────────────────────────────────────
//   document.querySelectorAll('.bundle-product-card').forEach(card => {
//     card.addEventListener('click', e => {
//       if (e.target.closest('.buy-single, .buy-bundle')) return;

//       popupTitle.innerText   = card.dataset.title   || '';
//       popupPrice.innerText   = card.dataset.price   || '';
//       popupDesc.innerHTML    = card.dataset.desc    || '';   // ←←← YEH CHANGE KIA HAI

//       popupImage.style.display = 'none';
//       popupVideo.style.display = 'none';
//       popupVideo.pause();
//       popupVideoSrc.src = '';

//       // 🎯 Priority: popup video → hover video → image
//       const popupVideoEl = card.querySelector('[data-popup-video] source');
//       const hoverVideoEl = card.querySelector('.hover-video source');

//       let chosenVideo = null;

//       if (popupVideoEl && popupVideoEl.src) {
//         chosenVideo = popupVideoEl.src;
//       } else if (hoverVideoEl && hoverVideoEl.src) {
//         chosenVideo = hoverVideoEl.src;
//       }

//       if (chosenVideo) {
//         popupVideoSrc.src = chosenVideo;
//         popupVideo.load();
//         popupVideo.style.display = 'block';
//         popupVideo.muted = true;
//         popupVideo.loop = true;
//         popupVideo.oncanplay = () => {
//           popupVideo.play().catch(() => {});
//           if (videoToggle) videoToggle.innerText = '❚❚';
//         };
//       } else {
//         // fallback image
//         const mainImg = card.querySelector('.main-img');
//         if (mainImg) popupImage.src = mainImg.src;
//         popupImage.style.display = 'block';
//       }

//       popupAdd.dataset.id = card.dataset.id;
//       popupBuy.dataset.id = card.dataset.id;

//       productPopup.classList.add('active');
//     });
//   });

//   // ────────────────────────────────────────────────
//   // CLOSE POPUP
//   // ────────────────────────────────────────────────
//   const closePopup = () => {
//     if (popupVideo) popupVideo.pause();
//     productPopup.classList.remove('active');
//   };

//   document.querySelector('.popup-back')?.addEventListener('click', closePopup);
//   document.querySelector('.popup-overlay')?.addEventListener('click', closePopup);

//   // ────────────────────────────────────────────────
//   // HELPER: Update cart count
//   // ────────────────────────────────────────────────
//   async function updateCartCount() {
//     try {
//       const res = await fetch('/cart.js');
//       if (!res.ok) return;
//       const cart = await res.json();
//       const el = document.querySelector('.custom-navbar__cart-count-aogntn0htnvpamzzlraigenblock92d2e51e8tjk6');
//       if (el) {
//         el.textContent = cart.item_count || 0;
//         el.style.display = cart.item_count > 0 ? 'block' : 'none';
//       }
//     } catch (err) {
//       console.warn('Cart count update failed', err);
//     }
//   }

//   // ────────────────────────────────────────────────
//   // HELPER: Notification
//   // ────────────────────────────────────────────────
//   function showNotification(msg, isError = false) {
//     const div = document.createElement('div');
//     div.textContent = msg;
//     div.style.cssText = `
//       position:fixed; top:80px; right:20px; z-index:9999;
//       padding:16px 24px; border-radius:8px; color:white; font-weight:bold;
//       background:${isError ? '#e74c3c' : '#2ecc71'};
//       box-shadow:0 4px 12px rgba(0,0,0,0.3); transition:all 0.4s;
//     `;
//     document.body.appendChild(div);
//     setTimeout(() => {
//       div.style.opacity = '0';
//       div.style.transform = 'translateY(-20px)';
//       setTimeout(() => div.remove(), 600);
//     }, 2500);
//   }

//   // ────────────────────────────────────────────────
//   // ADD TO CART (popup)
//   // ────────────────────────────────────────────────
//   if (popupAdd) {
//     popupAdd.addEventListener('click', async (e) => {
//       e.preventDefault();
//       if (popupAdd.disabled) return;

//       const id = popupAdd.dataset.id;
//       if (!id) return showNotification("No product selected.", true);

//       popupAdd.disabled = true;
//       popupAdd.textContent = "Adding...";

//       try {
//         const res = await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ id, quantity: 1 })
//         });

//         if (!res.ok) {
//           if (res.status === 429) throw new Error("Too many requests. Please wait a few seconds.");
//           throw new Error("Add to cart failed");
//         }

//         popupAdd.disabled = false;
//         popupAdd.textContent = "Add to Cart";

//         productPopup.classList.remove('active');
//         showNotification("Product added to your cart!");
//         await updateCartCount();

//       } catch (err) {
//         popupAdd.disabled = false;
//         popupAdd.textContent = "Add to Cart";
//         showNotification("Sorry: " + err.message, true);
//         console.error(err);
//       }
//     });
//   }

//   // ────────────────────────────────────────────────
//   // BUY IT NOW (popup)
//   // ────────────────────────────────────────────────
//   if (popupBuy) {
//     popupBuy.addEventListener('click', async (e) => {
//       e.preventDefault();
//       if (popupBuy.disabled) return;

//       const id = popupBuy.dataset.id;
//       if (!id) return showNotification("No product selected.", true);

//       popupBuy.disabled = true;
//       popupBuy.textContent = "Processing...";

//       try {
//         const res = await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ id, quantity: 1 })
//         });

//         if (!res.ok) {
//           if (res.status === 429) throw new Error("Too many requests. Please wait a few seconds.");
//           throw new Error("Add to cart failed");
//         }

//         productPopup.classList.remove('active');
//         window.location.href = '/cart';

//       } catch (err) {
//         popupBuy.disabled = false;
//         popupBuy.textContent = "Buy It Now";
//         showNotification("Error: " + err.message, true);
//         console.error(err);
//       }
//     });
//   }

//   // ────────────────────────────────────────────────
//   // EXTRA PRODUCT POPUP FOR .buy-bundle BUTTONS
//   // ────────────────────────────────────────────────
//   document.querySelectorAll('.buy-bundle').forEach(btn => {
//     btn.addEventListener('click', async (e) => {
//       e.preventDefault();
//       e.stopPropagation();

//       const extraHandle = btn.dataset.extraProductHandle?.trim();
//       const singleId    = btn.dataset.singleProduct;

//       if (extraHandle && extraHandle.length > 0) {
//         try {
//           const res = await fetch(`/products/${extraHandle}.js`);
//           if (!res.ok) throw new Error("Product fetch failed");
//           const product = await res.json();

//           popupTitle.innerText = product.title || 'Extra Product';

//           // ←←← YEH CHANGE KIA HAI (ab extra product ki asli description aayegi)
//           popupDesc.innerHTML = product.description || '';

//           const price = product.variants?.[0]?.price || 0;
//           popupPrice.innerHTML = Shopify?.formatMoney?.(price, '{{ shop.money_format | escape }}') || (price / 100).toFixed(2);

//           popupAdd.dataset.id = product.variants?.[0]?.id;
//           popupBuy.dataset.id = product.variants?.[0]?.id;

//           popupImage.style.display = 'none';
//           popupVideo.style.display = 'none';
//           popupVideo.pause();
//           popupVideoSrc.src = '';

//           let videoFound = false;
//           for (const media of (product.media || [])) {
//             if (media.media_type === 'video' && media.sources?.[0]?.url) {
//               popupVideoSrc.src = media.sources[0].url;
//               popupVideo.load();
//               popupVideo.style.display = 'block';
//               popupVideo.muted = true;
//               popupVideo.loop = true;
//               popupVideo.oncanplay = () => {
//                 popupVideo.play().catch(() => {});
//                 if (videoToggle) videoToggle.innerText = '❚❚';
//               };
//               videoFound = true;
//               break;
//             }
//           }

//           if (!videoFound && product.images?.[0]) {
//             popupImage.src = product.images[0];
//             popupImage.style.display = 'block';
//           }

//           productPopup.classList.add('active');
//         } catch (err) {
//           console.error("Extra product error:", err);
//           showNotification("Failed to load the additional product.", true);
//         }
//       } else if (singleId) {
//         const card = document.querySelector(`.bundle-product-card[data-id="${singleId}"]`);
//         if (card) card.click();
//       }
//     });
//   });

// });










// document.addEventListener("DOMContentLoaded", function () {

//   // ────────────────────────────────────────────────
//   // TAB SWITCHING + CATEGORY CARD CLICK + ACTIVE CLASS
//   // ────────────────────────────────────────────────
//   document.querySelectorAll('.tab, .category-card').forEach(item => {
//     item.addEventListener('click', () => {
//       const isCategoryCard = item.classList.contains('category-card');
//       const isAllTab       = item.dataset.filter === 'all';
//       const category       = item.dataset.category;
//       const subcategory    = item.dataset.sub || null;

//       document.querySelectorAll('.tab').forEach(tab => tab.classList.remove('active'));

//       if (!isCategoryCard) {
//         item.classList.add('active');
//       }

//       if (isCategoryCard && category) {
//         const matchingTab = document.querySelector(`.tab.category-tab[data-category="${category}"]`);
//         if (matchingTab) {
//           matchingTab.classList.add('active');
//           const subTabs = matchingTab.nextElementSibling;
//           if (subTabs?.classList.contains('sub-tabs')) {
//             document.querySelectorAll('.sub-tabs').forEach(s => {
//               if (s !== subTabs) s.style.display = 'none';
//             });
//             subTabs.style.display = 'block';
//           }
//         }
//       }

//       document.querySelectorAll('.view').forEach(view => {
//         view.classList.remove('active');

//         if (isAllTab && view.dataset.view === 'all') {
//           view.classList.add('active');
//           return;
//         }

//         if (category && !subcategory && view.dataset.category === category) {
//           view.classList.add('active');
//         }

//         if (subcategory && view.dataset.category === category && view.dataset.sub === subcategory) {
//           view.classList.add('active');
//         }
//       });
//     });
//   });

//   // ────────────────────────────────────────────────
//   // CATEGORY ACCORDION (sub-tabs open/close)
//   // ────────────────────────────────────────────────
//   document.querySelectorAll('.category-tab').forEach(tab => {
//     tab.addEventListener('click', (e) => {
//       e.stopPropagation();
//       const subTabs = tab.nextElementSibling;
//       if (!subTabs || !subTabs.classList.contains('sub-tabs')) return;

//       document.querySelectorAll('.sub-tabs').forEach(s => {
//         if (s !== subTabs) s.style.display = 'none';
//       });

//       subTabs.style.display = subTabs.style.display === 'block' ? 'none' : 'block';
//     });
//   });

//   // ────────────────────────────────────────────────
//   // VIDEO HOVER ON CARDS
//   // ────────────────────────────────────────────────
//   document.querySelectorAll('.bundle-product-card').forEach(card => {
//     const video = card.querySelector('video');
//     if (!video) return;

//     card.addEventListener('mouseenter', () => {
//       video.currentTime = 0;
//       video.play().catch(() => {});
//     });
//     card.addEventListener('mouseleave', () => video.pause());
//   });

//   // ────────────────────────────────────────────────
//   // PRODUCT POPUP ELEMENTS
//   // ────────────────────────────────────────────────
//   const productPopup     = document.getElementById('productPopup');
//   if (!productPopup) return;

//   const popupImage       = document.getElementById('popupImage');
//   const popupVideo       = document.getElementById('popupVideo');
//   const popupVideoSrc    = document.getElementById('popupVideoSrc');
//   const popupTitle       = document.getElementById('popupTitle');
//   const popupPrice       = document.getElementById('popupPrice');
//   const popupDesc        = document.getElementById('popupDesc');
//   const popupAdd         = document.getElementById('popupAdd');
//   const popupBuy         = document.getElementById('popupBuy');
//   const videoToggle      = document.getElementById('videoToggle');

//   // ────────────────────────────────────────────────
//   // VIDEO PLAY/PAUSE in PRODUCT POPUP
//   // ────────────────────────────────────────────────
//   document.addEventListener("DOMContentLoaded", () => {
//     const video = document.getElementById("popupVideo");
//     const toggleBtn = document.getElementById("videoToggle");
//     const currentTimeEl = document.getElementById("vcur");
//     const durationEl   = document.getElementById("vdur");

//     if (!video || !toggleBtn) return;

//     // Format time MM:SS
//     function formatTime(seconds) {
//       const min = Math.floor(seconds / 60);
//       const sec = Math.floor(seconds % 60);
//       return `${min}:${sec.toString().padStart(2, "0")}`;
//     }

//     // Update duration once when metadata is loaded
//     video.addEventListener("loadedmetadata", () => {
//       durationEl.textContent = formatTime(video.duration || 0);
//     });

//     // Update current time continuously
//     video.addEventListener("timeupdate", () => {
//       currentTimeEl.textContent = formatTime(video.currentTime);
//     });

//     // Play / Pause toggle
//     toggleBtn.addEventListener("click", () => {
//       if (video.paused || video.ended) {
//         video.play().catch(e => console.log("Play prevented:", e));
//         toggleBtn.textContent = "❚❚";
//         toggleBtn.classList.remove("yt-play");
//         toggleBtn.classList.add("yt-pause");
//       } else {
//         video.pause();
//         toggleBtn.textContent = "▶";
//         toggleBtn.classList.remove("yt-pause");
//         toggleBtn.classList.add("yt-play");
//       }
//     });

//     // Optional: clicking video itself also toggles play/pause
//     video.addEventListener("click", () => {
//       toggleBtn.click();
//     });

//     // Reset button to play icon when video ends
//     video.addEventListener("ended", () => {
//       toggleBtn.textContent = "▶";
//       toggleBtn.classList.remove("yt-pause");
//       toggleBtn.classList.add("yt-play");
//     });
//   });

//   // ────────────────────────────────────────────────
//   // OPEN POPUP FROM PRODUCT CARD
//   // ────────────────────────────────────────────────
//   document.querySelectorAll('.bundle-product-card').forEach(card => {
//     card.addEventListener('click', e => {
//       if (e.target.closest('.buy-single, .buy-bundle')) return;

//       popupTitle.innerText   = card.dataset.title   || '';
//       popupPrice.innerText   = card.dataset.price   || '';
//       popupDesc.innerHTML    = card.dataset.desc    || '';   // ←←← YEH CHANGE KIA HAI

//       popupImage.style.display = 'none';
//       popupVideo.style.display = 'none';
//       popupVideo.pause();
//       popupVideoSrc.src = '';

//       // 🎯 Priority: popup video → hover video → image
//       const popupVideoEl = card.querySelector('[data-popup-video] source');
//       const hoverVideoEl = card.querySelector('.hover-video source');

//       let chosenVideo = null;

//       if (popupVideoEl && popupVideoEl.src) {
//         chosenVideo = popupVideoEl.src;
//       } else if (hoverVideoEl && hoverVideoEl.src) {
//         chosenVideo = hoverVideoEl.src;
//       }

//       if (chosenVideo) {
//         popupVideoSrc.src = chosenVideo;
//         popupVideo.load();
//         popupVideo.style.display = 'block';
//         popupVideo.muted = true;
//         popupVideo.loop = true;
//         popupVideo.oncanplay = () => {
//           popupVideo.play().catch(() => {});
//           if (videoToggle) videoToggle.innerText = '❚❚';
//         };
//       } else {
//         // fallback image
//         const mainImg = card.querySelector('.main-img');
//         if (mainImg) popupImage.src = mainImg.src;
//         popupImage.style.display = 'block';
//       }

//       popupAdd.dataset.id = card.dataset.id;
//       popupBuy.dataset.id = card.dataset.id;

//       productPopup.classList.add('active');
//     });
//   });

//   // ────────────────────────────────────────────────
//   // CLOSE POPUP
//   // ────────────────────────────────────────────────
//   const closePopup = () => {
//     if (popupVideo) popupVideo.pause();
//     productPopup.classList.remove('active');
//   };

//   document.querySelector('.popup-back')?.addEventListener('click', closePopup);
//   document.querySelector('.popup-overlay')?.addEventListener('click', closePopup);

//   // ────────────────────────────────────────────────
//   // HELPER: Update cart count
//   // ────────────────────────────────────────────────
//   async function updateCartCount() {
//     try {
//       const res = await fetch('/cart.js');
//       if (!res.ok) return;
//       const cart = await res.json();
//       const count = cart.item_count || 0;
//       const el = document.querySelector('[class^="custom-navbar__cart-count-"]');
//       if (el) {
//         el.textContent = count;
//         el.style.display = count > 0 ? 'block' : 'none';
//       }
//     } catch (err) {
//       console.warn('Cart count update failed', err);
//     }
//   }

//   // ────────────────────────────────────────────────
//   // HELPER: Notification
//   // ────────────────────────────────────────────────
//   function showNotification(msg, isError = false) {
//     const div = document.createElement('div');
//     div.textContent = msg;
//     div.style.cssText = `
//       position:fixed; top:80px; right:20px; z-index:9999;
//       padding:16px 24px; border-radius:8px; color:white; font-weight:bold;
//       background:${isError ? '#e74c3c' : '#2ecc71'};
//       box-shadow:0 4px 12px rgba(0,0,0,0.3); transition:all 0.4s;
//     `;
//     document.body.appendChild(div);
//     setTimeout(() => {
//       div.style.opacity = '0';
//       div.style.transform = 'translateY(-20px)';
//       setTimeout(() => div.remove(), 600);
//     }, 2500);
//   }

//   // ────────────────────────────────────────────────
//   // ADD TO CART (popup)
//   // ────────────────────────────────────────────────
//   if (popupAdd) {
//     popupAdd.addEventListener('click', async (e) => {
//       e.preventDefault();
//       if (popupAdd.disabled) return;

//       const id = popupAdd.dataset.id;
//       if (!id) return showNotification("No product selected.", true);

//       popupAdd.disabled = true;
//       popupAdd.textContent = "Adding...";

//       try {
//         const res = await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ id, quantity: 1 })
//         });

//         if (!res.ok) {
//           if (res.status === 429) throw new Error("Too many requests. Please wait a few seconds.");
//           throw new Error("Add to cart failed");
//         }

//         popupAdd.disabled = false;
//         popupAdd.textContent = "Add to Cart";

//         productPopup.classList.remove('active');
//         showNotification("Product added to your cart!");
//         await updateCartCount();

//       } catch (err) {
//         popupAdd.disabled = false;
//         popupAdd.textContent = "Add to Cart";
//         showNotification("Sorry: " + err.message, true);
//         console.error(err);
//       }
//     });
//   }

//   // ────────────────────────────────────────────────
//   // BUY IT NOW (popup)
//   // ────────────────────────────────────────────────
//   if (popupBuy) {
//     popupBuy.addEventListener('click', async (e) => {
//       e.preventDefault();
//       if (popupBuy.disabled) return;

//       const id = popupBuy.dataset.id;
//       if (!id) return showNotification("No product selected.", true);

//       popupBuy.disabled = true;
//       popupBuy.textContent = "Processing...";

//       try {
//         const res = await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ id, quantity: 1 })
//         });

//         if (!res.ok) {
//           if (res.status === 429) throw new Error("Too many requests. Please wait a few seconds.");
//           throw new Error("Add to cart failed");
//         }

//         productPopup.classList.remove('active');
//         window.location.href = '/cart';

//       } catch (err) {
//         popupBuy.disabled = false;
//         popupBuy.textContent = "Buy It Now";
//         showNotification("Error: " + err.message, true);
//         console.error(err);
//       }
//     });
//   }

//   // ────────────────────────────────────────────────
//   // EXTRA PRODUCT POPUP FOR .buy-bundle BUTTONS
//   // ────────────────────────────────────────────────
//   document.querySelectorAll('.buy-bundle').forEach(btn => {
//     btn.addEventListener('click', async (e) => {
//       e.preventDefault();
//       e.stopPropagation();

//       const extraHandle = btn.dataset.extraProductHandle?.trim();
//       const singleId    = btn.dataset.singleProduct;

//       if (extraHandle && extraHandle.length > 0) {
//         try {
//           const res = await fetch(`/products/${extraHandle}.js`);
//           if (!res.ok) throw new Error("Product fetch failed");
//           const product = await res.json();

//           popupTitle.innerText = product.title || 'Extra Product';

//           // ←←← YEH CHANGE KIA HAI (ab extra product ki asli description aayegi)
//           popupDesc.innerHTML = product.description || '';

//           const price = product.variants?.[0]?.price || 0;
//           popupPrice.innerHTML = Shopify?.formatMoney?.(price, '{{ shop.money_format | escape }}') || (price / 100).toFixed(2);

//           popupAdd.dataset.id = product.variants?.[0]?.id;
//           popupBuy.dataset.id = product.variants?.[0]?.id;

//           popupImage.style.display = 'none';
//           popupVideo.style.display = 'none';
//           popupVideo.pause();
//           popupVideoSrc.src = '';

//           let videoFound = false;
//           for (const media of (product.media || [])) {
//             if (media.media_type === 'video' && media.sources?.[0]?.url) {
//               popupVideoSrc.src = media.sources[0].url;
//               popupVideo.load();
//               popupVideo.style.display = 'block';
//               popupVideo.muted = true;
//               popupVideo.loop = true;
//               popupVideo.oncanplay = () => {
//                 popupVideo.play().catch(() => {});
//                 if (videoToggle) videoToggle.innerText = '❚❚';
//               };
//               videoFound = true;
//               break;
//             }
//           }

//           if (!videoFound && product.images?.[0]) {
//             popupImage.src = product.images[0];
//             popupImage.style.display = 'block';
//           }

//           productPopup.classList.add('active');
//         } catch (err) {
//           console.error("Extra product error:", err);
//           showNotification("Failed to load the additional product.", true);
//         }
//       } else if (singleId) {
//         const card = document.querySelector(`.bundle-product-card[data-id="${singleId}"]`);
//         if (card) card.click();
//       }
//     });
//   });

// });





// document.addEventListener("DOMContentLoaded", function () {

//   // ────────────────────────────────────────────────
//   // TAB SWITCHING + CATEGORY CARD CLICK + ACTIVE CLASS
//   // ────────────────────────────────────────────────
//   document.querySelectorAll('.tab, .category-card').forEach(item => {
//     item.addEventListener('click', () => {
//       const isCategoryCard = item.classList.contains('category-card');
//       const isAllTab       = item.dataset.filter === 'all';
//       const category       = item.dataset.category;
//       const subcategory    = item.dataset.sub || null;

//       document.querySelectorAll('.tab').forEach(tab => tab.classList.remove('active'));

//       if (!isCategoryCard) {
//         item.classList.add('active');
//       }

//       if (isCategoryCard && category) {
//         const matchingTab = document.querySelector(`.tab.category-tab[data-category="${category}"]`);
//         if (matchingTab) {
//           matchingTab.classList.add('active');
//           const subTabs = matchingTab.nextElementSibling;
//           if (subTabs?.classList.contains('sub-tabs')) {
//             document.querySelectorAll('.sub-tabs').forEach(s => {
//               if (s !== subTabs) s.style.display = 'none';
//             });
//             subTabs.style.display = 'block';
//           }
//         }
//       }

//       document.querySelectorAll('.view').forEach(view => {
//         view.classList.remove('active');

//         if (isAllTab && view.dataset.view === 'all') {
//           view.classList.add('active');
//           return;
//         }

//         if (category && !subcategory && view.dataset.category === category) {
//           view.classList.add('active');
//         }

//         if (subcategory && view.dataset.category === category && view.dataset.sub === subcategory) {
//           view.classList.add('active');
//         }
//       });
//     });
//   });

//   // ────────────────────────────────────────────────
//   // CATEGORY ACCORDION (sub-tabs open/close)
//   // ────────────────────────────────────────────────
//   document.querySelectorAll('.category-tab').forEach(tab => {
//     tab.addEventListener('click', (e) => {
//       e.stopPropagation();
//       const subTabs = tab.nextElementSibling;
//       if (!subTabs || !subTabs.classList.contains('sub-tabs')) return;

//       document.querySelectorAll('.sub-tabs').forEach(s => {
//         if (s !== subTabs) s.style.display = 'none';
//       });

//       subTabs.style.display = subTabs.style.display === 'block' ? 'none' : 'block';
//     });
//   });

//   // ────────────────────────────────────────────────
//   // VIDEO HOVER ON CARDS
//   // ────────────────────────────────────────────────
//   document.querySelectorAll('.bundle-product-card').forEach(card => {
//     const video = card.querySelector('video');
//     if (!video) return;

//     card.addEventListener('mouseenter', () => {
//       video.currentTime = 0;
//       video.play().catch(() => {});
//     });
//     card.addEventListener('mouseleave', () => video.pause());
//   });

//   // ────────────────────────────────────────────────
//   // PRODUCT POPUP ELEMENTS
//   // ────────────────────────────────────────────────
//   const productPopup     = document.getElementById('productPopup');
//   if (!productPopup) return;

//   const popupImage       = document.getElementById('popupImage');
//   const popupVideo       = document.getElementById('popupVideo');
//   const popupVideoSrc    = document.getElementById('popupVideoSrc');
//   const popupTitle       = document.getElementById('popupTitle');
//   const popupPrice       = document.getElementById('popupPrice');
//   const popupDesc        = document.getElementById('popupDesc');
//   const popupAdd         = document.getElementById('popupAdd');
//   const popupBuy         = document.getElementById('popupBuy');
//   const videoToggle      = document.getElementById('videoToggle');

//   // ────────────────────────────────────────────────
//   // VIDEO PLAY/PAUSE in PRODUCT POPUP
//   // ────────────────────────────────────────────────
//   document.addEventListener("DOMContentLoaded", () => {
//     const video = document.getElementById("popupVideo");
//     const toggleBtn = document.getElementById("videoToggle");
//     const currentTimeEl = document.getElementById("vcur");
//     const durationEl   = document.getElementById("vdur");

//     if (!video || !toggleBtn) return;

//     // Format time MM:SS
//     function formatTime(seconds) {
//       const min = Math.floor(seconds / 60);
//       const sec = Math.floor(seconds % 60);
//       return `${min}:${sec.toString().padStart(2, "0")}`;
//     }

//     // Update duration once when metadata is loaded
//     video.addEventListener("loadedmetadata", () => {
//       durationEl.textContent = formatTime(video.duration || 0);
//     });

//     // Update current time continuously
//     video.addEventListener("timeupdate", () => {
//       currentTimeEl.textContent = formatTime(video.currentTime);
//     });

//     // Play / Pause toggle
//     toggleBtn.addEventListener("click", () => {
//       if (video.paused || video.ended) {
//         video.play().catch(e => console.log("Play prevented:", e));
//         toggleBtn.textContent = "❚❚";
//         toggleBtn.classList.remove("yt-play");
//         toggleBtn.classList.add("yt-pause");
//       } else {
//         video.pause();
//         toggleBtn.textContent = "▶";
//         toggleBtn.classList.remove("yt-pause");
//         toggleBtn.classList.add("yt-play");
//       }
//     });

//     // Optional: clicking video itself also toggles play/pause
//     video.addEventListener("click", () => {
//       toggleBtn.click();
//     });

//     // Reset button to play icon when video ends
//     video.addEventListener("ended", () => {
//       toggleBtn.textContent = "▶";
//       toggleBtn.classList.remove("yt-pause");
//       toggleBtn.classList.add("yt-play");
//     });
//   });

//   // ────────────────────────────────────────────────
//   // HELPER: Update cart count
//   // ────────────────────────────────────────────────
//   async function updateCartCount() {
//     try {
//       const res = await fetch('/cart.js');
//       if (!res.ok) return;
//       const cart = await res.json();
//       const count = cart.item_count || 0;
//       const el = document.querySelector('[class^="custom-navbar__cart-count-"]');
//       if (el) {
//         el.textContent = count;
//         el.style.display = count > 0 ? 'block' : 'none';
//       }
//     } catch (err) {
//       console.warn('Cart count update failed', err);
//     }
//   }

//   // ────────────────────────────────────────────────
//   // HELPER: Notification
//   // ────────────────────────────────────────────────
//   function showNotification(msg, isError = false) {
//     const div = document.createElement('div');
//     div.textContent = msg;
//     div.style.cssText = `
//       position:fixed; top:80px; right:20px; z-index:9999;
//       padding:16px 24px; border-radius:8px; color:white; font-weight:bold;
//       background:${isError ? '#e74c3c' : '#2ecc71'};
//       box-shadow:0 4px 12px rgba(0,0,0,0.3); transition:all 0.4s;
//     `;
//     document.body.appendChild(div);
//     setTimeout(() => {
//       div.style.opacity = '0';
//       div.style.transform = 'translateY(-20px)';
//       setTimeout(() => div.remove(), 600);
//     }, 2500);
//   }

//   // ────────────────────────────────────────────────
//   // PRODUCT VARIANTS DROPDOWN FEATURE
//   // ────────────────────────────────────────────────
  
//   // Create variant selector container
//   function createVariantSelector() {
//     // Check if selector already exists
//     if (document.getElementById('variantOptionsContainer')) return;
    
//     const variantContainer = document.createElement('div');
//     variantContainer.id = 'variantOptionsContainer';
//     variantContainer.className = 'variant-options-container';
//     variantContainer.style.cssText = `
//       margin: 0px 0;
//       width: 100%;
//     `;
    
//     // Insert after popupPrice in the popup-right
//     const popupRight = document.querySelector('.popup-right');
//     const popupPriceDiv = document.getElementById('popupAdd');
    
//     if (popupRight && popupPriceDiv) {
//       popupPriceDiv.parentNode.insertBefore(variantContainer, popupPriceDiv.nextSibling);
//     }
//   }
  
//   createVariantSelector();
  
//   const variantContainer = document.getElementById('variantOptionsContainer');
  
//   // Store current product data
//   let currentProductData = null;
  
//   // Function to fetch complete product data by handle or ID
//   async function fetchProductData(productIdentifier) {
//     try {
//       // Try to extract product handle from the card or use the ID
//       let url = '';
      
//       // Check if it's a numeric ID (variant ID) or handle
//       if (isNaN(productIdentifier)) {
//         // It's a handle
//         url = `/products/${productIdentifier}.js`;
//       } else {
//         // For variant ID, we need to find the product first
//         // This is a simplified approach - in production you might want to store product handle in data attribute
//         const card = document.querySelector(`[data-id="${productIdentifier}"]`);
//         if (card && card.dataset.handle) {
//           url = `/products/${card.dataset.handle}.js`;
//         } else {
//           // If we can't get handle, try to fetch by ID (might not work)
//           console.log('Cannot determine product handle');
//           return null;
//         }
//       }
      
//       const res = await fetch(url);
//       if (!res.ok) throw new Error('Product fetch failed');
//       const product = await res.json();
//       return product;
//     } catch (err) {
//       console.error('Error fetching product:', err);
//       return null;
//     }
//   }
  
//   // Function to render variant options based on Shopify variant structure
//   function renderVariantOptions(product) {
//     if (!variantContainer || !product || !product.variants || product.variants.length <= 1) {
//       if (variantContainer) variantContainer.innerHTML = '';
//       return false;
//     }
    
//     currentProductData = product;
    
//     // Group variants by option
//     const options = product.options || [];
//     let html = '';
    
//     // Create dropdowns for each option
//     options.forEach((option, index) => {
//       const optionName = option.name;
//       const optionValues = [...new Set(product.variants.map(v => v.options[index]))];
      
//       html += `
//         <div class="variant-option-group" style="">
//           <label style="display: block; margin-bottom: 5px; font-weight: 600; color: #fff;">${optionName}:</label>
//           <select class="variant-option-select" data-option-index="${index}" style="
//             width: 100%;
//             padding: 7px 6px;
//             border: 1px solid #ddd;
//             border-radius: 5px;
//             background: #fff;
//             font-size: 13px;
//             cursor: pointer;
//           ">
//             ${optionValues.map(value => `<option value="${value}">${value}</option>`).join('')}
//           </select>
//         </div>
//       `;
//     });
    
//     // Add price display for selected variant
//     html += `
//       <div class="selected-variant-info" style="margin-top: 10px; padding: 10px; background: #f5f5f5; border-radius: 5px;">
//         <div style="display: flex; justify-content: space-between; align-items: center;">
//           <span style="font-weight: 600;">Selected Variant:</span>
//           <span id="selectedVariantPrice" style="font-size: 18px; color: #007bff;">${formatMoney(product.variants[0].price)}</span>
//         </div>
//       </div>
//     `;
    
//     variantContainer.innerHTML = html;
//     variantContainer.style.display = 'block';
    
//     // Add event listeners to selects
//     document.querySelectorAll('.variant-option-select').forEach(select => {
//       select.addEventListener('change', updateSelectedVariant);
//     });
    
//     // Set initial variant
//     updateSelectedVariant();
    
//     return true;
//   }
  
//   // Helper function to format money
//   function formatMoney(price) {
//     if (Shopify && Shopify.formatMoney) {
//       return Shopify.formatMoney(price, '{{ shop.money_format | escape }}');
//     }
//     return `$${(price / 100).toFixed(2)}`;
//   }
  
//   // Function to update selected variant based on dropdown selections
//   function updateSelectedVariant() {
//     if (!currentProductData || !currentProductData.variants) return;
    
//     const selects = document.querySelectorAll('.variant-option-select');
//     const selectedOptions = Array.from(selects).map(select => select.value);
    
//     // Find matching variant
//     const matchingVariant = currentProductData.variants.find(variant => {
//       return variant.options.every((opt, index) => opt === selectedOptions[index]);
//     });
    
//     if (matchingVariant) {
//       // Update price display
//       const priceElement = document.getElementById('selectedVariantPrice');
//       if (priceElement) {
//         priceElement.textContent = formatMoney(matchingVariant.price);
//       }
      
//       // Update main price display
//       if (popupPrice) {
//         popupPrice.textContent = formatMoney(matchingVariant.price);
//       }
      
//       // Update add to cart and buy now buttons with selected variant ID
//       if (popupAdd) popupAdd.dataset.id = matchingVariant.id;
//       if (popupBuy) popupBuy.dataset.id = matchingVariant.id;
//     }
//   }
  
//   // ────────────────────────────────────────────────
//   // MODIFIED OPEN POPUP FROM PRODUCT CARD
//   // ────────────────────────────────────────────────
//   document.querySelectorAll('.bundle-product-card').forEach(card => {
//     // Add product handle to card data for better variant fetching
//     // You'll need to add data-handle attribute to your card in Liquid
//     // Like: data-handle="{{ product.handle }}"
    
//     card.addEventListener('click', async function(e) {
//       if (e.target.closest('.buy-single, .buy-bundle, .variant-option-select')) return;

//       // Clear previous variant options
//       if (variantContainer) {
//         variantContainer.innerHTML = '';
//       }
      
//       // Get product handle - you need to add this to your card HTML
//       const productHandle = this.dataset.handle;
//       const productId = this.dataset.id;
      
//       // Set basic info
//       popupTitle.innerText   = this.dataset.title   || '';
//       popupDesc.innerHTML    = this.dataset.desc    || '';
      
//       // Fetch complete product data for variants
//       if (productHandle) {
//         const product = await fetchProductData(productHandle);
//         if (product && product.variants && product.variants.length > 1) {
//           // Product has variants - show variant selector
//           renderVariantOptions(product);
          
//           // Update price with first variant price
//           if (popupPrice) {
//             popupPrice.textContent = formatMoney(product.variants[0].price);
//           }
          
//           // Set initial variant ID
//           if (popupAdd) popupAdd.dataset.id = product.variants[0].id;
//           if (popupBuy) popupBuy.dataset.id = product.variants[0].id;
//         } else {
//           // No variants - show single product price
//           popupPrice.innerText = this.dataset.price || '';
//           popupAdd.dataset.id = productId;
//           popupBuy.dataset.id = productId;
//         }
//       } else {
//         // Fallback if no handle
//         popupPrice.innerText = this.dataset.price || '';
//         popupAdd.dataset.id = productId;
//         popupBuy.dataset.id = productId;
//       }

//       // Handle media (images/videos) - your existing code
//       popupImage.style.display = 'none';
//       popupVideo.style.display = 'none';
//       popupVideo.pause();
//       popupVideoSrc.src = '';

//       const popupVideoEl = this.querySelector('[data-popup-video] source');
//       const hoverVideoEl = this.querySelector('.hover-video source');

//       let chosenVideo = null;

//       if (popupVideoEl && popupVideoEl.src) {
//         chosenVideo = popupVideoEl.src;
//       } else if (hoverVideoEl && hoverVideoEl.src) {
//         chosenVideo = hoverVideoEl.src;
//       }

//       if (chosenVideo) {
//         popupVideoSrc.src = chosenVideo;
//         popupVideo.load();
//         popupVideo.style.display = 'block';
//         popupVideo.muted = true;
//         popupVideo.loop = true;
//         popupVideo.oncanplay = () => {
//           popupVideo.play().catch(() => {});
//           if (videoToggle) videoToggle.innerText = '❚❚';
//         };
//       } else {
//         const mainImg = this.querySelector('.main-img');
//         if (mainImg) popupImage.src = mainImg.src;
//         popupImage.style.display = 'block';
//       }

//       productPopup.classList.add('active');
//     });
//   });

//   // ────────────────────────────────────────────────
//   // CLOSE POPUP
//   // ────────────────────────────────────────────────
//   const closePopup = () => {
//     if (popupVideo) popupVideo.pause();
//     productPopup.classList.remove('active');
//     // Clear variant container
//     if (variantContainer) {
//       variantContainer.innerHTML = '';
//     }
//   };

//   document.querySelector('.popup-back')?.addEventListener('click', closePopup);
//   document.querySelector('.popup-overlay')?.addEventListener('click', closePopup);

//   // ────────────────────────────────────────────────
//   // ADD TO CART (popup) - MODIFIED TO USE SELECTED VARIANT
//   // ────────────────────────────────────────────────
//   if (popupAdd) {
//     popupAdd.addEventListener('click', async (e) => {
//       e.preventDefault();
//       if (popupAdd.disabled) return;

//       const variantId = popupAdd.dataset.id;
//       if (!variantId) return showNotification("No product selected.", true);

//       popupAdd.disabled = true;
//       popupAdd.textContent = "Adding...";

//       try {
//         const res = await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ id: variantId, quantity: 1 })
//         });

//         if (!res.ok) {
//           if (res.status === 429) throw new Error("Too many requests. Please wait a few seconds.");
//           throw new Error("Add to cart failed");
//         }

//         popupAdd.disabled = false;
//         popupAdd.textContent = "Add to Cart";

//         productPopup.classList.remove('active');
//         showNotification("Product added to your cart!");
//         await updateCartCount();

//       } catch (err) {
//         popupAdd.disabled = false;
//         popupAdd.textContent = "Add to Cart";
//         showNotification("Sorry: " + err.message, true);
//         console.error(err);
//       }
//     });
//   }

//   // ────────────────────────────────────────────────
//   // BUY IT NOW (popup) - MODIFIED TO USE SELECTED VARIANT
//   // ────────────────────────────────────────────────
//   if (popupBuy) {
//     popupBuy.addEventListener('click', async (e) => {
//       e.preventDefault();
//       if (popupBuy.disabled) return;

//       const variantId = popupBuy.dataset.id;
//       if (!variantId) return showNotification("No product selected.", true);

//       popupBuy.disabled = true;
//       popupBuy.textContent = "Processing...";

//       try {
//         const res = await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ id: variantId, quantity: 1 })
//         });

//         if (!res.ok) {
//           if (res.status === 429) throw new Error("Too many requests. Please wait a few seconds.");
//           throw new Error("Add to cart failed");
//         }

//         productPopup.classList.remove('active');
//         window.location.href = '/cart';

//       } catch (err) {
//         popupBuy.disabled = false;
//         popupBuy.textContent = "Buy It Now";
//         showNotification("Error: " + err.message, true);
//         console.error(err);
//       }
//     });
//   }

//   // ────────────────────────────────────────────────
//   // EXTRA PRODUCT POPUP FOR .buy-bundle BUTTONS
//   // ────────────────────────────────────────────────
//   document.querySelectorAll('.buy-bundle').forEach(btn => {
//     btn.addEventListener('click', async (e) => {
//       e.preventDefault();
//       e.stopPropagation();

//       const extraHandle = btn.dataset.extraProductHandle?.trim();
//       const singleId    = btn.dataset.singleProduct;

//       if (extraHandle && extraHandle.length > 0) {
//         try {
//           const res = await fetch(`/products/${extraHandle}.js`);
//           if (!res.ok) throw new Error("Product fetch failed");
//           const product = await res.json();

//           popupTitle.innerText = product.title || 'Extra Product';
//           popupDesc.innerHTML = product.description || '';

//           // Check for variants
//           if (product.variants && product.variants.length > 1) {
//             renderVariantOptions(product);
//             popupPrice.textContent = formatMoney(product.variants[0].price);
//             popupAdd.dataset.id = product.variants[0].id;
//             popupBuy.dataset.id = product.variants[0].id;
//           } else {
//             const price = product.variants?.[0]?.price || 0;
//             popupPrice.innerHTML = formatMoney(price);
//             popupAdd.dataset.id = product.variants?.[0]?.id;
//             popupBuy.dataset.id = product.variants?.[0]?.id;
//           }

//           popupImage.style.display = 'none';
//           popupVideo.style.display = 'none';
//           popupVideo.pause();
//           popupVideoSrc.src = '';

//           let videoFound = false;
//           for (const media of (product.media || [])) {
//             if (media.media_type === 'video' && media.sources?.[0]?.url) {
//               popupVideoSrc.src = media.sources[0].url;
//               popupVideo.load();
//               popupVideo.style.display = 'block';
//               popupVideo.muted = true;
//               popupVideo.loop = true;
//               popupVideo.oncanplay = () => {
//                 popupVideo.play().catch(() => {});
//                 if (videoToggle) videoToggle.innerText = '❚❚';
//               };
//               videoFound = true;
//               break;
//             }
//           }

//           if (!videoFound && product.images?.[0]) {
//             popupImage.src = product.images[0];
//             popupImage.style.display = 'block';
//           }

//           productPopup.classList.add('active');
//         } catch (err) {
//           console.error("Extra product error:", err);
//           showNotification("Failed to load the additional product.", true);
//         }
//       } else if (singleId) {
//         const card = document.querySelector(`.bundle-product-card[data-id="${singleId}"]`);
//         if (card) card.click();
//       }
//     });
//   });

//   // Add CSS for variant options
//   const style = document.createElement('style');
//   style.textContent = `
//     .variant-option-group label {
//       display: block;
//       margin-bottom: 5px;
//       font-weight: 600;
//       color: #fff;
//     }
//     .variant-option-select {
//       width: 100%;
//       padding: 6px;
//       border: 1px solid #ddd;
//       border-radius: 5px;
//       background: #fff;
//       font-size: 14px;
//       cursor: pointer;
//     }
//     .variant-option-select:hover {
//       border-color: #999;
//     }
//     .variant-option-select:focus {
//       outline: none;
//       border-color: #007bff;
//     }
//     .selected-variant-info {
//       margin-top: 10px;
//       padding: 10px;
//       background: #f5f5f5;
//       border-radius: 5px;
//     }
//     #selectedVariantPrice {
//       font-size: 18px;
//       color: #007bff;
//       font-weight: 600;
//     }
//   `;
//   document.head.appendChild(style);

// });








// document.addEventListener("DOMContentLoaded", function () {

//   // ────────────────────────────────────────────────
//   // TAB SWITCHING + CATEGORY CARD CLICK + ACTIVE CLASS
//   // ────────────────────────────────────────────────
//   document.querySelectorAll('.tab, .category-card').forEach(item => {
//     item.addEventListener('click', () => {
//       const isCategoryCard = item.classList.contains('category-card');
//       const isAllTab       = item.dataset.filter === 'all';
//       const category       = item.dataset.category;
//       const subcategory    = item.dataset.sub || null;

//       document.querySelectorAll('.tab').forEach(tab => tab.classList.remove('active'));

//       if (!isCategoryCard) {
//         item.classList.add('active');
//       }

//       if (isCategoryCard && category) {
//         const matchingTab = document.querySelector(`.tab.category-tab[data-category="${category}"]`);
//         if (matchingTab) {
//           matchingTab.classList.add('active');
//           const subTabs = matchingTab.nextElementSibling;
//           if (subTabs?.classList.contains('sub-tabs')) {
//             document.querySelectorAll('.sub-tabs').forEach(s => {
//               if (s !== subTabs) s.style.display = 'none';
//             });
//             subTabs.style.display = 'block';
//           }
//         }
//       }

//       document.querySelectorAll('.view').forEach(view => {
//         view.classList.remove('active');

//         if (isAllTab && view.dataset.view === 'all') {
//           view.classList.add('active');
//           return;
//         }

//         if (category && !subcategory && view.dataset.category === category) {
//           view.classList.add('active');
//         }

//         if (subcategory && view.dataset.category === category && view.dataset.sub === subcategory) {
//           view.classList.add('active');
//         }
//       });
//     });
//   });

//   // ────────────────────────────────────────────────
//   // CATEGORY ACCORDION (sub-tabs open/close)
//   // ────────────────────────────────────────────────
//   document.querySelectorAll('.category-tab').forEach(tab => {
//     tab.addEventListener('click', (e) => {
//       e.stopPropagation();
//       const subTabs = tab.nextElementSibling;
//       if (!subTabs || !subTabs.classList.contains('sub-tabs')) return;

//       document.querySelectorAll('.sub-tabs').forEach(s => {
//         if (s !== subTabs) s.style.display = 'none';
//       });

//       subTabs.style.display = subTabs.style.display === 'block' ? 'none' : 'block';
//     });
//   });

//   // ────────────────────────────────────────────────
//   // VIDEO HOVER ON CARDS
//   // ────────────────────────────────────────────────
//   document.querySelectorAll('.bundle-product-card').forEach(card => {
//     const video = card.querySelector('video');
//     if (!video) return;

//     card.addEventListener('mouseenter', () => {
//       video.currentTime = 0;
//       video.play().catch(() => {});
//     });
//     card.addEventListener('mouseleave', () => video.pause());
//   });

//   // ────────────────────────────────────────────────
//   // PRODUCT POPUP ELEMENTS
//   // ────────────────────────────────────────────────
//   const productPopup     = document.getElementById('productPopup');
//   if (!productPopup) return;

//   const popupImage       = document.getElementById('popupImage');
//   const popupVideo       = document.getElementById('popupVideo');
//   const popupVideoSrc    = document.getElementById('popupVideoSrc');
//   const popupTitle       = document.getElementById('popupTitle');
//   const popupPrice       = document.getElementById('popupPrice');
//   const popupDesc        = document.getElementById('popupDesc');
//   const popupAdd         = document.getElementById('popupAdd');
//   const popupBuy         = document.getElementById('popupBuy');
//   const videoToggle      = document.getElementById('videoToggle');

//   // ────────────────────────────────────────────────
//   // VIDEO PLAY/PAUSE in PRODUCT POPUP
//   // ────────────────────────────────────────────────
//   document.addEventListener("DOMContentLoaded", () => {
//     const video = document.getElementById("popupVideo");
//     const toggleBtn = document.getElementById("videoToggle");
//     const currentTimeEl = document.getElementById("vcur");
//     const durationEl   = document.getElementById("vdur");

//     if (!video || !toggleBtn) return;

//     // Format time MM:SS
//     function formatTime(seconds) {
//       const min = Math.floor(seconds / 60);
//       const sec = Math.floor(seconds % 60);
//       return `${min}:${sec.toString().padStart(2, "0")}`;
//     }

//     // Update duration once when metadata is loaded
//     video.addEventListener("loadedmetadata", () => {
//       durationEl.textContent = formatTime(video.duration || 0);
//     });

//     // Update current time continuously
//     video.addEventListener("timeupdate", () => {
//       currentTimeEl.textContent = formatTime(video.currentTime);
//     });

//     // Play / Pause toggle
//     toggleBtn.addEventListener("click", () => {
//       if (video.paused || video.ended) {
//         video.play().catch(e => console.log("Play prevented:", e));
//         toggleBtn.textContent = "❚❚";
//         toggleBtn.classList.remove("yt-play");
//         toggleBtn.classList.add("yt-pause");
//       } else {
//         video.pause();
//         toggleBtn.textContent = "▶";
//         toggleBtn.classList.remove("yt-pause");
//         toggleBtn.classList.add("yt-play");
//       }
//     });

//     // Optional: clicking video itself also toggles play/pause
//     video.addEventListener("click", () => {
//       toggleBtn.click();
//     });

//     // Reset button to play icon when video ends
//     video.addEventListener("ended", () => {
//       toggleBtn.textContent = "▶";
//       toggleBtn.classList.remove("yt-pause");
//       toggleBtn.classList.add("yt-play");
//     });
//   });

//   // ────────────────────────────────────────────────
//   // HELPER: Update cart count
//   // ────────────────────────────────────────────────
//   async function updateCartCount() {
//     try {
//       const res = await fetch('/cart.js');
//       if (!res.ok) return;
//       const cart = await res.json();
//       const count = cart.item_count || 0;
//       const el = document.querySelector('[class^="custom-navbar__cart-count-"]');
//       if (el) {
//         el.textContent = count;
//         el.style.display = count > 0 ? 'block' : 'none';
//       }
//     } catch (err) {
//       console.warn('Cart count update failed', err);
//     }
//   }

//   // ────────────────────────────────────────────────
// // HELPER: Backend refresh after add to cart
// // ────────────────────────────────────────────────
// async function refreshBackendPage() {
//   try {
//     await fetch('/cart.js', { cache: "no-store" }); 
//     window.location.reload(); // page reload
//   } catch (err) {
//     console.warn('Backend refresh failed', err);
//     window.location.reload();
//   }
// }

//   // ────────────────────────────────────────────────
//   // HELPER: Notification
//   // ────────────────────────────────────────────────
//   function showNotification(msg, isError = false) {
//     const div = document.createElement('div');
//     div.textContent = msg;
//     div.style.cssText = `
//       position:fixed; top:80px; right:20px; z-index:9999;
//       padding:16px 24px; border-radius:8px; color:white; font-weight:bold;
//       background:${isError ? '#e74c3c' : '#2ecc71'};
//       box-shadow:0 4px 12px rgba(0,0,0,0.3); transition:all 0.4s;
//     `;
//     document.body.appendChild(div);
//     setTimeout(() => {
//       div.style.opacity = '0';
//       div.style.transform = 'translateY(-20px)';
//       setTimeout(() => div.remove(), 600);
//     }, 2500);
//   }

//   // ────────────────────────────────────────────────
//   // PRODUCT VARIANTS DROPDOWN FEATURE
//   // ────────────────────────────────────────────────
  
//   // Create variant selector container
//   function createVariantSelector() {
//     // Check if selector already exists
//     if (document.getElementById('variantOptionsContainer')) return;
    
//     const variantContainer = document.createElement('div');
//     variantContainer.id = 'variantOptionsContainer';
//     variantContainer.className = 'variant-options-container';
//     variantContainer.style.cssText = `
//       margin: 0px 0;
//       width: 100%;
//     `;
    
//     // Insert after popupPrice in the popup-right
//     const popupRight = document.querySelector('.popup-right');
//     const popupPriceDiv = document.getElementById('popupAdd');
    
//     if (popupRight && popupPriceDiv) {
//       popupPriceDiv.parentNode.insertBefore(variantContainer, popupPriceDiv.nextSibling);
//     }
//   }
  
//   createVariantSelector();
  
//   const variantContainer = document.getElementById('variantOptionsContainer');
  
//   // Store current product data
//   let currentProductData = null;
  
//   // Function to fetch complete product data by handle or ID
//   async function fetchProductData(productIdentifier) {
//     try {
//       // Try to extract product handle from the card or use the ID
//       let url = '';
      
//       // Check if it's a numeric ID (variant ID) or handle
//       if (isNaN(productIdentifier)) {
//         // It's a handle
//         url = `/products/${productIdentifier}.js`;
//       } else {
//         // For variant ID, we need to find the product first
//         // This is a simplified approach - in production you might want to store product handle in data attribute
//         const card = document.querySelector(`[data-id="${productIdentifier}"]`);
//         if (card && card.dataset.handle) {
//           url = `/products/${card.dataset.handle}.js`;
//         } else {
//           // If we can't get handle, try to fetch by ID (might not work)
//           console.log('Cannot determine product handle');
//           return null;
//         }
//       }
      
//       const res = await fetch(url);
//       if (!res.ok) throw new Error('Product fetch failed');
//       const product = await res.json();
//       return product;
//     } catch (err) {
//       console.error('Error fetching product:', err);
//       return null;
//     }
//   }
  
//   // Function to render variant options based on Shopify variant structure
//   function renderVariantOptions(product) {
//     if (!variantContainer || !product || !product.variants || product.variants.length <= 1) {
//       if (variantContainer) variantContainer.innerHTML = '';
//       return false;
//     }
    
//     currentProductData = product;
    
//     // Group variants by option
//     const options = product.options || [];
//     let html = '';
    
//     // Create dropdowns for each option
//     options.forEach((option, index) => {
//       const optionName = option.name;
//       const optionValues = [...new Set(product.variants.map(v => v.options[index]))];
      
//       html += `
//         <div class="variant-option-group" style="">
//           <label style="display: block; margin-bottom: 5px; font-weight: 600; color: #fff;">${optionName}:</label>
//           <select class="variant-option-select" data-option-index="${index}" style="
//             width: 100%;
//             padding: 7px 6px;
//             border: 1px solid #ddd;
//             border-radius: 5px;
//             background: #fff;
//             font-size: 13px;
//             cursor: pointer;
//           ">
//             ${optionValues.map(value => `<option value="${value}">${value}</option>`).join('')}
//           </select>
//         </div>
//       `;
//     });
    
//     // Add price display for selected variant
//     html += `
//       <div class="selected-variant-info" style="margin-top: 10px; padding: 10px; background: #f5f5f5; border-radius: 5px;">
//         <div style="display: flex; justify-content: space-between; align-items: center;">
//           <span style="font-weight: 600;">Selected Variant:</span>
//           <span id="selectedVariantPrice" style="font-size: 18px; color: #007bff;">${formatMoney(product.variants[0].price)}</span>
//         </div>
//       </div>
//     `;
    
//     variantContainer.innerHTML = html;
//     variantContainer.style.display = 'block';
    
//     // Add event listeners to selects
//     document.querySelectorAll('.variant-option-select').forEach(select => {
//       select.addEventListener('change', updateSelectedVariant);
//     });
    
//     // Set initial variant
//     updateSelectedVariant();
    
//     return true;
//   }
  
//   // Helper function to format money
//   function formatMoney(price) {
//     if (Shopify && Shopify.formatMoney) {
//       return Shopify.formatMoney(price, '{{ shop.money_format | escape }}');
//     }
//     return `$${(price / 100).toFixed(2)}`;
//   }
  
//   // Function to update selected variant based on dropdown selections
//   function updateSelectedVariant() {
//     if (!currentProductData || !currentProductData.variants) return;
    
//     const selects = document.querySelectorAll('.variant-option-select');
//     const selectedOptions = Array.from(selects).map(select => select.value);
    
//     // Find matching variant
//     const matchingVariant = currentProductData.variants.find(variant => {
//       return variant.options.every((opt, index) => opt === selectedOptions[index]);
//     });
    
//     if (matchingVariant) {
//       // Update price display
//       const priceElement = document.getElementById('selectedVariantPrice');
//       if (priceElement) {
//         priceElement.textContent = formatMoney(matchingVariant.price);
//       }
      
//       // Update main price display
//       if (popupPrice) {
//         popupPrice.textContent = formatMoney(matchingVariant.price);
//       }
      
//       // Update add to cart and buy now buttons with selected variant ID
//       if (popupAdd) popupAdd.dataset.id = matchingVariant.id;
//       if (popupBuy) popupBuy.dataset.id = matchingVariant.id;
//     }
//   }
  
//   // ────────────────────────────────────────────────
//   // MODIFIED OPEN POPUP FROM PRODUCT CARD
//   // ────────────────────────────────────────────────
//   document.querySelectorAll('.bundle-product-card').forEach(card => {
//     // Add product handle to card data for better variant fetching
//     // You'll need to add data-handle attribute to your card in Liquid
//     // Like: data-handle="{{ product.handle }}"
    
//     card.addEventListener('click', async function(e) {
//       if (e.target.closest('.buy-single, .buy-bundle, .variant-option-select')) return;

//       // Clear previous variant options
//       if (variantContainer) {
//         variantContainer.innerHTML = '';
//       }
      
//       // Get product handle - you need to add this to your card HTML
//       const productHandle = this.dataset.handle;
//       const productId = this.dataset.id;
      
//       // Set basic info
//       popupTitle.innerText   = this.dataset.title   || '';
//       popupDesc.innerHTML    = this.dataset.desc    || '';
      
//       // Fetch complete product data for variants
//       if (productHandle) {
//         const product = await fetchProductData(productHandle);
//         if (product && product.variants && product.variants.length > 1) {
//           // Product has variants - show variant selector
//           renderVariantOptions(product);
          
//           // Update price with first variant price
//           if (popupPrice) {
//             popupPrice.textContent = formatMoney(product.variants[0].price);
//           }
          
//           // Set initial variant ID
//           if (popupAdd) popupAdd.dataset.id = product.variants[0].id;
//           if (popupBuy) popupBuy.dataset.id = product.variants[0].id;
//         } else {
//           // No variants - show single product price
//           popupPrice.innerText = this.dataset.price || '';
//           popupAdd.dataset.id = productId;
//           popupBuy.dataset.id = productId;
//         }
//       } else {
//         // Fallback if no handle
//         popupPrice.innerText = this.dataset.price || '';
//         popupAdd.dataset.id = productId;
//         popupBuy.dataset.id = productId;
//       }

//       // Handle media (images/videos) - your existing code
//       popupImage.style.display = 'none';
//       popupVideo.style.display = 'none';
//       popupVideo.pause();
//       popupVideoSrc.src = '';

//       const popupVideoEl = this.querySelector('[data-popup-video] source');
//       const hoverVideoEl = this.querySelector('.hover-video source');

//       let chosenVideo = null;

//       if (popupVideoEl && popupVideoEl.src) {
//         chosenVideo = popupVideoEl.src;
//       } else if (hoverVideoEl && hoverVideoEl.src) {
//         chosenVideo = hoverVideoEl.src;
//       }

//       if (chosenVideo) {
//         popupVideoSrc.src = chosenVideo;
//         popupVideo.load();
//         popupVideo.style.display = 'block';
//         popupVideo.muted = true;
//         popupVideo.loop = true;
//         popupVideo.oncanplay = () => {
//           popupVideo.play().catch(() => {});
//           if (videoToggle) videoToggle.innerText = '❚❚';
//         };
//       } else {
//         const mainImg = this.querySelector('.main-img');
//         if (mainImg) popupImage.src = mainImg.src;
//         popupImage.style.display = 'block';
//       }

//       productPopup.classList.add('active');
//     });
//   });

//   // ────────────────────────────────────────────────
//   // CLOSE POPUP
//   // ────────────────────────────────────────────────
//   const closePopup = () => {
//     if (popupVideo) popupVideo.pause();
//     productPopup.classList.remove('active');
//     // Clear variant container
//     if (variantContainer) {
//       variantContainer.innerHTML = '';
//     }
//   };

//   document.querySelector('.popup-back')?.addEventListener('click', closePopup);
//   document.querySelector('.popup-overlay')?.addEventListener('click', closePopup);

//   // ────────────────────────────────────────────────
//   // ADD TO CART (popup) - MODIFIED TO USE SELECTED VARIANT
//   // ────────────────────────────────────────────────
//   if (popupAdd) {
//     popupAdd.addEventListener('click', async (e) => {
//       e.preventDefault();
//       if (popupAdd.disabled) return;

//       const variantId = popupAdd.dataset.id;
//       if (!variantId) return showNotification("No product selected.", true);

//       popupAdd.disabled = true;
//       popupAdd.textContent = "Adding...";

//       try {
//         const res = await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ id: variantId, quantity: 1 })
//         });

//         if (!res.ok) {
//           if (res.status === 429) throw new Error("Too many requests. Please wait a few seconds.");
//           throw new Error("Add to cart failed");
//         }

//         popupAdd.disabled = false;
//         popupAdd.textContent = "Add to Cart";

//         productPopup.classList.remove('active');
//         showNotification("Product added to your cart!");
// await updateCartCount();
// await refreshBackendPage();

//       } catch (err) {
//         popupAdd.disabled = false;
//         popupAdd.textContent = "Add to Cart";
//         showNotification("Sorry: " + err.message, true);
//         console.error(err);
//       }
//     });
//   }

//   // ────────────────────────────────────────────────
//   // BUY IT NOW (popup) - MODIFIED TO USE SELECTED VARIANT
//   // ────────────────────────────────────────────────
//   if (popupBuy) {
//     popupBuy.addEventListener('click', async (e) => {
//       e.preventDefault();
//       if (popupBuy.disabled) return;

//       const variantId = popupBuy.dataset.id;
//       if (!variantId) return showNotification("No product selected.", true);

//       popupBuy.disabled = true;
//       popupBuy.textContent = "Processing...";

//       try {
//         const res = await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ id: variantId, quantity: 1 })
//         });

//         if (!res.ok) {
//           if (res.status === 429) throw new Error("Too many requests. Please wait a few seconds.");
//           throw new Error("Add to cart failed");
//         }

//         productPopup.classList.remove('active');
//         window.location.href = '/cart';

//       } catch (err) {
//         popupBuy.disabled = false;
//         popupBuy.textContent = "Buy It Now";
//         showNotification("Error: " + err.message, true);
//         console.error(err);
//       }
//     });
//   }

//   // ────────────────────────────────────────────────
//   // EXTRA PRODUCT POPUP FOR .buy-bundle BUTTONS
//   // ────────────────────────────────────────────────
//   document.querySelectorAll('.buy-bundle').forEach(btn => {
//     btn.addEventListener('click', async (e) => {
//       e.preventDefault();
//       e.stopPropagation();

//       const extraHandle = btn.dataset.extraProductHandle?.trim();
//       const singleId    = btn.dataset.singleProduct;

//       if (extraHandle && extraHandle.length > 0) {
//         try {
//           const res = await fetch(`/products/${extraHandle}.js`);
//           if (!res.ok) throw new Error("Product fetch failed");
//           const product = await res.json();

//           popupTitle.innerText = product.title || 'Extra Product';
//           popupDesc.innerHTML = product.description || '';

//           // Check for variants
//           if (product.variants && product.variants.length > 1) {
//             renderVariantOptions(product);
//             popupPrice.textContent = formatMoney(product.variants[0].price);
//             popupAdd.dataset.id = product.variants[0].id;
//             popupBuy.dataset.id = product.variants[0].id;
//           } else {
//             const price = product.variants?.[0]?.price || 0;
//             popupPrice.innerHTML = formatMoney(price);
//             popupAdd.dataset.id = product.variants?.[0]?.id;
//             popupBuy.dataset.id = product.variants?.[0]?.id;
//           }

//           popupImage.style.display = 'none';
//           popupVideo.style.display = 'none';
//           popupVideo.pause();
//           popupVideoSrc.src = '';

//           let videoFound = false;
//           for (const media of (product.media || [])) {
//             if (media.media_type === 'video' && media.sources?.[0]?.url) {
//               popupVideoSrc.src = media.sources[0].url;
//               popupVideo.load();
//               popupVideo.style.display = 'block';
//               popupVideo.muted = true;
//               popupVideo.loop = true;
//               popupVideo.oncanplay = () => {
//                 popupVideo.play().catch(() => {});
//                 if (videoToggle) videoToggle.innerText = '❚❚';
//               };
//               videoFound = true;
//               break;
//             }
//           }

//           if (!videoFound && product.images?.[0]) {
//             popupImage.src = product.images[0];
//             popupImage.style.display = 'block';
//           }

//           productPopup.classList.add('active');
//         } catch (err) {
//           console.error("Extra product error:", err);
//           showNotification("Failed to load the additional product.", true);
//         }
//       } else if (singleId) {
//         const card = document.querySelector(`.bundle-product-card[data-id="${singleId}"]`);
//         if (card) card.click();
//       }
//     });
//   });

//   // Add CSS for variant options
//   const style = document.createElement('style');
//   style.textContent = `
//     .variant-option-group label {
//       display: block;
//       margin-bottom: 5px;
//       font-weight: 600;
//       color: #fff;
//     }
//     .variant-option-select {
//       width: 100%;
//       padding: 6px;
//       border: 1px solid #ddd;
//       border-radius: 5px;
//       background: #fff;
//       font-size: 14px;
//       cursor: pointer;
//     }
//     .variant-option-select:hover {
//       border-color: #999;
//     }
//     .variant-option-select:focus {
//       outline: none;
//       border-color: #007bff;
//     }
//     .selected-variant-info {
//       margin-top: 10px;
//       padding: 10px;
//       background: #f5f5f5;
//       border-radius: 5px;
//     }
//     #selectedVariantPrice {
//       font-size: 18px;
//       color: #007bff;
//       font-weight: 600;
//     }
//   `;
//   document.head.appendChild(style);

// });





















document.addEventListener("DOMContentLoaded", function () {

  // ────────────────────────────────────────────────
  // TAB SWITCHING + CATEGORY CARD CLICK + ACTIVE CLASS
  // ────────────────────────────────────────────────
  document.querySelectorAll('.tab, .category-card').forEach(item => {
    item.addEventListener('click', () => {
      const isCategoryCard = item.classList.contains('category-card');
      const isAllTab       = item.dataset.filter === 'all';
      const category       = item.dataset.category;
      const subcategory    = item.dataset.sub || null;

      document.querySelectorAll('.tab').forEach(tab => tab.classList.remove('active'));

      if (!isCategoryCard) {
        item.classList.add('active');
      }

      if (isCategoryCard && category) {
        const matchingTab = document.querySelector(`.tab.category-tab[data-category="${category}"]`);
        if (matchingTab) {
          matchingTab.classList.add('active');
          const subTabs = matchingTab.nextElementSibling;
          if (subTabs?.classList.contains('sub-tabs')) {
            document.querySelectorAll('.sub-tabs').forEach(s => {
              if (s !== subTabs) s.style.display = 'none';
            });
            subTabs.style.display = 'block';
          }
        }
      }

      document.querySelectorAll('.view').forEach(view => {
        view.classList.remove('active');

        if (isAllTab && view.dataset.view === 'all') {
          view.classList.add('active');
          return;
        }

        if (category && !subcategory && view.dataset.category === category) {
          view.classList.add('active');
        }

        if (subcategory && view.dataset.category === category && view.dataset.sub === subcategory) {
          view.classList.add('active');
        }
      });
    });
  });

  // ────────────────────────────────────────────────
  // CATEGORY ACCORDION (sub-tabs open/close)
  // ────────────────────────────────────────────────
  document.querySelectorAll('.category-tab').forEach(tab => {
    tab.addEventListener('click', (e) => {
      e.stopPropagation();
      const subTabs = tab.nextElementSibling;
      if (!subTabs || !subTabs.classList.contains('sub-tabs')) return;

      document.querySelectorAll('.sub-tabs').forEach(s => {
        if (s !== subTabs) s.style.display = 'none';
      });

      subTabs.style.display = subTabs.style.display === 'block' ? 'none' : 'block';
    });
  });

  // ────────────────────────────────────────────────
  // VIDEO HOVER ON CARDS
  // ────────────────────────────────────────────────
  document.querySelectorAll('.bundle-product-card').forEach(card => {
    const video = card.querySelector('video');
    if (!video) return;

    card.addEventListener('mouseenter', () => {
      video.currentTime = 0;
      video.play().catch(() => {});
    });
    card.addEventListener('mouseleave', () => video.pause());
  });

  // ────────────────────────────────────────────────
  // PRODUCT POPUP ELEMENTS
  // ────────────────────────────────────────────────
  const productPopup     = document.getElementById('productPopup');
  if (!productPopup) return;

  const popupImage       = document.getElementById('popupImage');
  const popupVideo       = document.getElementById('popupVideo');
  const popupVideoSrc    = document.getElementById('popupVideoSrc');
  const popupTitle       = document.getElementById('popupTitle');
  const popupPrice       = document.getElementById('popupPrice');
  const popupDesc        = document.getElementById('popupDesc');
  const popupAdd         = document.getElementById('popupAdd');
  const popupBuy         = document.getElementById('popupBuy');
  const videoToggle      = document.getElementById('videoToggle');

  // ────────────────────────────────────────────────
  // VIDEO PLAY/PAUSE in PRODUCT POPUP
  // ────────────────────────────────────────────────
  document.addEventListener("DOMContentLoaded", () => {
    const video = document.getElementById("popupVideo");
    const toggleBtn = document.getElementById("videoToggle");
    const currentTimeEl = document.getElementById("vcur");
    const durationEl   = document.getElementById("vdur");

    if (!video || !toggleBtn) return;

    // Format time MM:SS
    function formatTime(seconds) {
      const min = Math.floor(seconds / 60);
      const sec = Math.floor(seconds % 60);
      return `${min}:${sec.toString().padStart(2, "0")}`;
    }

    // Update duration once when metadata is loaded
    video.addEventListener("loadedmetadata", () => {
      durationEl.textContent = formatTime(video.duration || 0);
    });

    // Update current time continuously
    video.addEventListener("timeupdate", () => {
      currentTimeEl.textContent = formatTime(video.currentTime);
    });

    // Play / Pause toggle
    toggleBtn.addEventListener("click", () => {
      if (video.paused || video.ended) {
        video.play().catch(e => console.log("Play prevented:", e));
        toggleBtn.textContent = "❚❚";
        toggleBtn.classList.remove("yt-play");
        toggleBtn.classList.add("yt-pause");
      } else {
        video.pause();
        toggleBtn.textContent = "▶";
        toggleBtn.classList.remove("yt-pause");
        toggleBtn.classList.add("yt-play");
      }
    });

    // Optional: clicking video itself also toggles play/pause
    video.addEventListener("click", () => {
      toggleBtn.click();
    });

    // Reset button to play icon when video ends
    video.addEventListener("ended", () => {
      toggleBtn.textContent = "▶";
      toggleBtn.classList.remove("yt-pause");
      toggleBtn.classList.add("yt-play");
    });
  });

  // ────────────────────────────────────────────────
  // ✅ FINAL FIXED: Cart count update function (ALWAYS SHOWS 0)
  // ────────────────────────────────────────────────
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js', { 
        cache: "no-store",
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      
      if (!res.ok) {
        throw new Error('Failed to fetch cart');
      }
      
      const cart = await res.json();
      const count = cart.item_count || 0;
      
      // Find ALL cart icon containers (both desktop and mobile)
      document.querySelectorAll('a[href="/cart"].custom-navbar__icon-aogntn0htnvpamzzlraigenblock92d2e51e8tjk6').forEach(cartLink => {
        // Check if span exists inside this cart link
        let countSpan = cartLink.querySelector('span[class*="custom-navbar__cart-count-"]');
        
        // If span doesn't exist, CREATE IT!
        if (!countSpan) {
          countSpan = document.createElement('span');
          countSpan.className = 'custom-navbar__cart-count-aogntn0htnvpamzzlraigenblock92d2e51e8tjk6';
          cartLink.appendChild(countSpan);
        }
        
        // Update the count - ALWAYS SHOW 0, NEVER HIDE
        countSpan.textContent = count;
        countSpan.style.display = 'block'; // Always show, even for 0
      });
      
      return count;
    } catch (err) {
      console.warn('Cart count update failed', err);
      return 0;
    }
  }

  // ────────────────────────────────────────────────
  // HELPER: Notification
  // ────────────────────────────────────────────────
  function showNotification(msg, isError = false) {
    const div = document.createElement('div');
    div.textContent = msg;
    div.style.cssText = `
      position:fixed; top:80px; right:20px; z-index:9999;
      padding:16px 24px; border-radius:8px; color:white; font-weight:bold;
      background:${isError ? '#e74c3c' : '#2ecc71'};
      box-shadow:0 4px 12px rgba(0,0,0,0.3); transition:all 0.4s;
    `;
    document.body.appendChild(div);
    setTimeout(() => {
      div.style.opacity = '0';
      div.style.transform = 'translateY(-20px)';
      setTimeout(() => div.remove(), 600);
    }, 2500);
  }

  // ────────────────────────────────────────────────
  // PRODUCT VARIANTS DROPDOWN FEATURE
  // ────────────────────────────────────────────────
  
  // Create variant selector container
  function createVariantSelector() {
    // Check if selector already exists
    if (document.getElementById('variantOptionsContainer')) return;
    
    const variantContainer = document.createElement('div');
    variantContainer.id = 'variantOptionsContainer';
    variantContainer.className = 'variant-options-container';
    variantContainer.style.cssText = `
      margin: 0px 0;
      width: 100%;
    `;
    
    // Insert after popupPrice in the popup-right
    const popupRight = document.querySelector('.popup-right');
    const popupPriceDiv = document.getElementById('popupAdd');
    
    if (popupRight && popupPriceDiv) {
      popupPriceDiv.parentNode.insertBefore(variantContainer, popupPriceDiv.nextSibling);
    }
  }
  
  createVariantSelector();
  
  const variantContainer = document.getElementById('variantOptionsContainer');
  
  // Store current product data
  let currentProductData = null;
  
  // Function to fetch complete product data by handle or ID
  async function fetchProductData(productIdentifier) {
    try {
      // Try to extract product handle from the card or use the ID
      let url = '';
      
      // Check if it's a numeric ID (variant ID) or handle
      if (isNaN(productIdentifier)) {
        // It's a handle
        url = `/products/${productIdentifier}.js`;
      } else {
        // For variant ID, we need to find the product first
        // This is a simplified approach - in production you might want to store product handle in data attribute
        const card = document.querySelector(`[data-id="${productIdentifier}"]`);
        if (card && card.dataset.handle) {
          url = `/products/${card.dataset.handle}.js`;
        } else {
          // If we can't get handle, try to fetch by ID (might not work)
          console.log('Cannot determine product handle');
          return null;
        }
      }
      
      const res = await fetch(url);
      if (!res.ok) throw new Error('Product fetch failed');
      const product = await res.json();
      return product;
    } catch (err) {
      console.error('Error fetching product:', err);
      return null;
    }
  }
  
  // Function to render variant options based on Shopify variant structure
  function renderVariantOptions(product) {
    if (!variantContainer || !product || !product.variants || product.variants.length <= 1) {
      if (variantContainer) variantContainer.innerHTML = '';
      return false;
    }
    
    currentProductData = product;
    
    // Group variants by option
    const options = product.options || [];
    let html = '';
    
    // Create dropdowns for each option
    options.forEach((option, index) => {
      const optionName = option.name;
      const optionValues = [...new Set(product.variants.map(v => v.options[index]))];
      
      html += `
        <div class="variant-option-group" style="">
          <label style="display: block; margin-bottom: 5px; font-weight: 600; color: #fff;">${optionName}:</label>
          <select class="variant-option-select" data-option-index="${index}" style="
            width: 100%;
            padding: 7px 6px;
            border: 1px solid #ddd;
            border-radius: 5px;
            background: #fff;
            font-size: 13px;
            cursor: pointer;
          ">
            ${optionValues.map(value => `<option value="${value}">${value}</option>`).join('')}
          </select>
        </div>
      `;
    });
    
    // Add price display for selected variant
    html += `
      <div class="selected-variant-info" style="margin-top: 10px; padding: 10px; background: #f5f5f5; border-radius: 5px;">
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <span style="font-weight: 600;">Selected Variant:</span>
          <span id="selectedVariantPrice" style="font-size: 18px; color: #007bff;">${formatMoney(product.variants[0].price)}</span>
        </div>
      </div>
    `;
    
    variantContainer.innerHTML = html;
    variantContainer.style.display = 'block';
    
    // Add event listeners to selects
    document.querySelectorAll('.variant-option-select').forEach(select => {
      select.addEventListener('change', updateSelectedVariant);
    });
    
    // Set initial variant
    updateSelectedVariant();
    
    return true;
  }
  
  // Helper function to format money
  function formatMoney(price) {
    if (Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(price, '{{ shop.money_format | escape }}');
    }
    return `$${(price / 100).toFixed(2)}`;
  }
  
  // Function to update selected variant based on dropdown selections
  function updateSelectedVariant() {
    if (!currentProductData || !currentProductData.variants) return;
    
    const selects = document.querySelectorAll('.variant-option-select');
    const selectedOptions = Array.from(selects).map(select => select.value);
    
    // Find matching variant
    const matchingVariant = currentProductData.variants.find(variant => {
      return variant.options.every((opt, index) => opt === selectedOptions[index]);
    });
    
    if (matchingVariant) {
      // Update price display
      const priceElement = document.getElementById('selectedVariantPrice');
      if (priceElement) {
        priceElement.textContent = formatMoney(matchingVariant.price);
      }
      
      // Update main price display
      if (popupPrice) {
        popupPrice.textContent = formatMoney(matchingVariant.price);
      }
      
      // Update add to cart and buy now buttons with selected variant ID
      if (popupAdd) popupAdd.dataset.id = matchingVariant.id;
      if (popupBuy) popupBuy.dataset.id = matchingVariant.id;
    }
  }
  
  // ────────────────────────────────────────────────
  // MODIFIED OPEN POPUP FROM PRODUCT CARD
  // ────────────────────────────────────────────────
  document.querySelectorAll('.bundle-product-card').forEach(card => {
    // Add product handle to card data for better variant fetching
    // You'll need to add data-handle attribute to your card in Liquid
    // Like: data-handle="{{ product.handle }}"
    
    card.addEventListener('click', async function(e) {
      if (e.target.closest('.buy-single, .buy-bundle, .variant-option-select')) return;

      // Clear previous variant options
      if (variantContainer) {
        variantContainer.innerHTML = '';
      }
      
      // Get product handle - you need to add this to your card HTML
      const productHandle = this.dataset.handle;
      const productId = this.dataset.id;
      
      // Set basic info
      popupTitle.innerText   = this.dataset.title   || '';
      popupDesc.innerHTML    = this.dataset.desc    || '';
      
      // Fetch complete product data for variants
      if (productHandle) {
        const product = await fetchProductData(productHandle);
        if (product && product.variants && product.variants.length > 1) {
          // Product has variants - show variant selector
          renderVariantOptions(product);
          
          // Update price with first variant price
          if (popupPrice) {
            popupPrice.textContent = formatMoney(product.variants[0].price);
          }
          
          // Set initial variant ID
          if (popupAdd) popupAdd.dataset.id = product.variants[0].id;
          if (popupBuy) popupBuy.dataset.id = product.variants[0].id;
        } else {
          // No variants - show single product price
          popupPrice.innerText = this.dataset.price || '';
          popupAdd.dataset.id = productId;
          popupBuy.dataset.id = productId;
        }
      } else {
        // Fallback if no handle
        popupPrice.innerText = this.dataset.price || '';
        popupAdd.dataset.id = productId;
        popupBuy.dataset.id = productId;
      }

      // Handle media (images/videos) - your existing code
      popupImage.style.display = 'none';
      popupVideo.style.display = 'none';
      popupVideo.pause();
      popupVideoSrc.src = '';

      const popupVideoEl = this.querySelector('[data-popup-video] source');
      const hoverVideoEl = this.querySelector('.hover-video source');

      let chosenVideo = null;

      if (popupVideoEl && popupVideoEl.src) {
        chosenVideo = popupVideoEl.src;
      } else if (hoverVideoEl && hoverVideoEl.src) {
        chosenVideo = hoverVideoEl.src;
      }

      if (chosenVideo) {
        popupVideoSrc.src = chosenVideo;
        popupVideo.load();
        popupVideo.style.display = 'block';
        popupVideo.muted = true;
        popupVideo.loop = true;
        popupVideo.oncanplay = () => {
          popupVideo.play().catch(() => {});
          if (videoToggle) videoToggle.innerText = '❚❚';
        };
      } else {
        const mainImg = this.querySelector('.main-img');
        if (mainImg) popupImage.src = mainImg.src;
        popupImage.style.display = 'block';
      }

      productPopup.classList.add('active');
    });
  });

  // ────────────────────────────────────────────────
  // CLOSE POPUP
  // ────────────────────────────────────────────────
  const closePopup = () => {
    if (popupVideo) popupVideo.pause();
    productPopup.classList.remove('active');
    // Clear variant container
    if (variantContainer) {
      variantContainer.innerHTML = '';
    }
  };

  document.querySelector('.popup-back')?.addEventListener('click', closePopup);
  document.querySelector('.popup-overlay')?.addEventListener('click', closePopup);

  // ────────────────────────────────────────────────
  // ✅ FIXED: ADD TO CART (popup) - UPDATES COUNT TO 0 IF NEEDED
  // ────────────────────────────────────────────────
  if (popupAdd) {
    popupAdd.addEventListener('click', async (e) => {
      e.preventDefault();
      if (popupAdd.disabled) return;

      const variantId = popupAdd.dataset.id;
      if (!variantId) return showNotification("No product selected.", true);

      popupAdd.disabled = true;
      popupAdd.textContent = "Adding...";

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (!res.ok) {
          if (res.status === 429) throw new Error("Too many requests. Please wait a few seconds.");
          throw new Error("Add to cart failed");
        }

        // ✅ Update cart count (will show 0 or any number, always visible)
        await updateCartCount();
        
        popupAdd.disabled = false;
        popupAdd.textContent = "Add to Cart";

        productPopup.classList.remove('active');
        showNotification("Product added to your cart!");

      } catch (err) {
        popupAdd.disabled = false;
        popupAdd.textContent = "Add to Cart";
        showNotification("Sorry: " + err.message, true);
        console.error(err);
      }
    });
  }

  // ────────────────────────────────────────────────
  // BUY IT NOW (popup)
  // ────────────────────────────────────────────────
  if (popupBuy) {
    popupBuy.addEventListener('click', async (e) => {
      e.preventDefault();
      if (popupBuy.disabled) return;

      const variantId = popupBuy.dataset.id;
      if (!variantId) return showNotification("No product selected.", true);

      popupBuy.disabled = true;
      popupBuy.textContent = "Processing...";

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (!res.ok) {
          if (res.status === 429) throw new Error("Too many requests. Please wait a few seconds.");
          throw new Error("Add to cart failed");
        }

        productPopup.classList.remove('active');
        
        // ✅ Update cart count before redirect
        await updateCartCount();
        
        // Redirect to cart page
        window.location.href = '/cart';

      } catch (err) {
        popupBuy.disabled = false;
        popupBuy.textContent = "Buy It Now";
        showNotification("Error: " + err.message, true);
        console.error(err);
      }
    });
  }

  // ────────────────────────────────────────────────
  // EXTRA PRODUCT POPUP FOR .buy-bundle BUTTONS
  // ────────────────────────────────────────────────
  document.querySelectorAll('.buy-bundle').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();

      const extraHandle = btn.dataset.extraProductHandle?.trim();
      const singleId    = btn.dataset.singleProduct;

      if (extraHandle && extraHandle.length > 0) {
        try {
          const res = await fetch(`/products/${extraHandle}.js`);
          if (!res.ok) throw new Error("Product fetch failed");
          const product = await res.json();

          popupTitle.innerText = product.title || 'Extra Product';
          popupDesc.innerHTML = product.description || '';

          // Check for variants
          if (product.variants && product.variants.length > 1) {
            renderVariantOptions(product);
            popupPrice.textContent = formatMoney(product.variants[0].price);
            popupAdd.dataset.id = product.variants[0].id;
            popupBuy.dataset.id = product.variants[0].id;
          } else {
            const price = product.variants?.[0]?.price || 0;
            popupPrice.innerHTML = formatMoney(price);
            popupAdd.dataset.id = product.variants?.[0]?.id;
            popupBuy.dataset.id = product.variants?.[0]?.id;
          }

          popupImage.style.display = 'none';
          popupVideo.style.display = 'none';
          popupVideo.pause();
          popupVideoSrc.src = '';

          let videoFound = false;
          for (const media of (product.media || [])) {
            if (media.media_type === 'video' && media.sources?.[0]?.url) {
              popupVideoSrc.src = media.sources[0].url;
              popupVideo.load();
              popupVideo.style.display = 'block';
              popupVideo.muted = true;
              popupVideo.loop = true;
              popupVideo.oncanplay = () => {
                popupVideo.play().catch(() => {});
                if (videoToggle) videoToggle.innerText = '❚❚';
              };
              videoFound = true;
              break;
            }
          }

          if (!videoFound && product.images?.[0]) {
            popupImage.src = product.images[0];
            popupImage.style.display = 'block';
          }

          productPopup.classList.add('active');
        } catch (err) {
          console.error("Extra product error:", err);
          // showNotification("Failed to load the additional product.", true);
        }
      } else if (singleId) {
        const card = document.querySelector(`.bundle-product-card[data-id="${singleId}"]`);
        if (card) card.click();
      }
    });
  });

  // Add CSS for variant options
  const style = document.createElement('style');
  style.textContent = `
    .variant-option-group label {
      display: block;
      margin-bottom: 5px;
      font-weight: 600;
      color: #fff;
    }
    .variant-option-select {
      width: 100%;
      padding: 6px;
      border: 1px solid #ddd;
      border-radius: 5px;
      background: #fff;
      font-size: 14px;
      cursor: pointer;
    }
    .variant-option-select:hover {
      border-color: #999;
    }
    .variant-option-select:focus {
      outline: none;
      border-color: #007bff;
    }
    .selected-variant-info {
      margin-top: 10px;
      padding: 10px;
      background: #f5f5f5;
      border-radius: 5px;
    }
    #selectedVariantPrice {
      font-size: 18px;
      color: #007bff;
      font-weight: 600;
    }
  `;
  document.head.appendChild(style);

  // ✅ Initialize cart count on page load (will show 0 if cart empty)
  updateCartCount();

  // ✅ Optional: Listen for cart updates from other sources (like cart page)
  // This will update the count when items are removed from cart page
  if (window.location.pathname === '/cart') {
    // Create a MutationObserver to watch for cart changes
    const observer = new MutationObserver(() => {
      updateCartCount();
    });
    
    // Observe the cart page for changes
    const cartContainer = document.querySelector('cart-items, .cart, [data-cart]');
    if (cartContainer) {
      observer.observe(cartContainer, { childList: true, subtree: true });
    }
  }

});






// document.addEventListener("DOMContentLoaded", function () {
//   const heroForm = document.querySelector(
//     ".ai-hero-video__search-form-avmprk3dzexhmu1ddqaigenblock6ca54cdlizpix"
//   );

//   if (!heroForm) return;

//   heroForm.addEventListener("submit", function () {
//     const searchInput = heroForm.querySelector(
//       ".ai-hero-video__search-input-avmprk3dzexhmu1ddqaigenblock6ca54cdlizpix"
//     );

//     if (searchInput && searchInput.value.trim() !== "") {
//       // value ko URL me store kar do
//       sessionStorage.setItem("bundleSearchValue", searchInput.value.trim());
//     }
//   });
// });

document.addEventListener("DOMContentLoaded", function () {

  const heroForm = document.querySelector(
    ".ai-hero-video__search-form-avmprk3dzexhmu1ddqaigenblock6ca54cdlizpix"
  );

  if (heroForm) {
    heroForm.addEventListener("submit", function () {
      const searchInput = heroForm.querySelector(
        ".ai-hero-video__search-input-avmprk3dzexhmu1ddqaigenblock6ca54cdlizpix"
      );

      if (searchInput && searchInput.value.trim() !== "") {
        sessionStorage.setItem("bundleSearchValue", searchInput.value.trim());
      }
    });
  }


  /* SEARCH PAGE PAR BUTTON SHOW KARNA */

  // const savedSearch = sessionStorage.getItem("bundleSearchValue");

  // if (savedSearch) {
  //   const clearBtn = document.querySelector(".clear-search");

  //   if (clearBtn) {
  //     clearBtn.style.display = "block";
  //   }
  // }

});

document.addEventListener("DOMContentLoaded", function () {

  const searchInput = document.querySelector("#bundleSearch");
  const clearBtn = document.querySelector(".clear-search");

  // initial state
  if (clearBtn) {
    clearBtn.style.display = "none";
  }

  // show/hide on typing
  if (searchInput && clearBtn) {
    searchInput.addEventListener("input", function () {
      if (searchInput.value.trim().length > 0) {
        clearBtn.style.display = "block";
      } else {
        clearBtn.style.display = "none";
      }
    });
  }

  // clear button click
  if (clearBtn && searchInput) {
    clearBtn.addEventListener("click", function () {
      searchInput.value = "";
      clearBtn.style.display = "none";
      searchInput.focus();
    });
  }

});



document.addEventListener('DOMContentLoaded', function () {
  const clearBtn = document.querySelector('.clear-search');

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      window.location.reload();
    });
  }
});



document.addEventListener('DOMContentLoaded', function () {
  const bundleSearch = document.querySelector('.bundle-search-wrapper');

  if (!bundleSearch) return;

  window.addEventListener('scroll', function () {
    if (window.scrollY > 20) {
      bundleSearch.classList.add('active');
    } else {
      bundleSearch.classList.remove('active');
    }
  });
});












document.addEventListener('DOMContentLoaded', () => {
  const v = document.getElementById('popupVideo');
  const playBtn = document.getElementById('videoToggle');

  const bar = document.getElementById('ytProgress');
  const played = bar.querySelector('.yt-progress-played');
  const buffer = bar.querySelector('.yt-progress-buffer');

  const cur = document.getElementById('vcur');
  const dur = document.getElementById('vdur');

  if (!v || !bar) return;

  function fmt(t){
    t = Math.floor(t || 0);
    return Math.floor(t/60)+':' + String(t%60).padStart(2,'0');
  }

  // 🔥 PURE 60FPS LOOP (YOUTUBE METHOD)
  function smooth(){
    if (v.duration){
      played.style.width = (v.currentTime / v.duration) * 100 + '%';
      cur.textContent = fmt(v.currentTime);
    }
    requestAnimationFrame(smooth);
  }
  smooth();

  // duration
  v.addEventListener('loadedmetadata', () => {
    dur.textContent = fmt(v.duration);
  });

  // play / pause
  playBtn.onclick = () => {
    if (v.paused){
      v.play();
      playBtn.textContent = '❚❚';
    } else {
      v.pause();
      playBtn.textContent = '▶';
    }
  };

  // seek on click (SUPER SMOOTH)
  bar.addEventListener('click', e => {
    const rect = bar.getBoundingClientRect();
    const p = (e.clientX - rect.left) / rect.width;
    v.currentTime = p * v.duration;
  });

  // buffer bar
  v.addEventListener('progress', () => {
    try{
      const b = v.buffered.end(v.buffered.length-1);
      buffer.style.width = (b / v.duration) * 100 + '%';
    }catch(e){}
  });

});

